import React from "react";
import { bgStyle, bgImageUrl } from "@/lib/gradients";

// Cadre d'un texte sur fond coloré/photo, partagé par le composeur ET les cartes publiées :
// ratio 4:3 + marge en % de la largeur → même mise en page (taille, retours à la ligne, centrage)
// quelle que soit la largeur (aperçu de rédaction, fil PC, téléphone).
export const BG_TEXT_PAD = "p-[5%]";
export const BG_TEXT_SHADOW = { textShadow: "0 1px 4px rgba(0,0,0,0.4)" };
// Plafond de police relatif à la largeur uniquement (pas de plafond fixe en px, sinon un cadre large casse la proportion).
export const BG_TEXT_MAX_PX = 400;

export const BgTextFrame = React.forwardRef(({ bg, className = "", children, ...rest }, ref) => (
  <div ref={ref} className={`relative overflow-hidden rounded-2xl aspect-[4/3] min-h-0 ${className}`} style={bgStyle(bg)} {...rest}>
    {bgImageUrl(bg) && <div className="absolute inset-0 bg-black/35" aria-hidden />}
    {children}
  </div>
));
BgTextFrame.displayName = "BgTextFrame";
